import React, { useState, forwardRef, useImperativeHandle } from 'react';
import '../../styles/projects/projects.css';
import { ReactComponent as MicroscopeIcon } from '../../assets/svg/analyze-svg.svg';

const WP1 = forwardRef((props, ref) => {
	const [isExpanded, setIsExpanded] = useState(false);

	const sectionRef = React.useRef(null);

	const toggleExpand = () => {
		setIsExpanded(!isExpanded);
	};

	useImperativeHandle(ref, () => ({
		expandSection() {
			if (sectionRef.current) {
				const yOffset = -100; 
				const y = sectionRef.current.getBoundingClientRect().top + window.pageYOffset + yOffset;
				window.scrollTo({ top: y, behavior: 'smooth' });
				setTimeout(() => {
					setIsExpanded(true);
				}, 350); 
			}
		},
	}));

	const leaders = [
		{ name: 'Carina Sihlbom Wallem (GU)', link: 'https://www.gu.se/om-universitetet/hitta-person/carinasihlbom' },
		{ name: 'Henrik Johansson (KI)', link: 'https://ki.se/en/people/henrik-johansson' },
		{ name: 'Anahita Bakochi (LU)', link: 'https://portal.research.lu.se/en/persons/anahita-bakochi' },
		{ name: 'Lazaro Hiram Betancourt Nunez (LU)', link: 'https://portal.research.lu.se/en/persons/lazaro-hiram-betancourt-nunez' },
		{ name: 'Annika Thorsell (GU)', link: 'https://www.gu.se/om-universitetet/hitta-person/annikathorsell' },
		{ name: 'Eduardo Araujo (KI)', link: 'https://ki.se/en/people/eduardo-araujo' },
		{ name: 'Renata Blatnik (Bruker)', link: null },
		{ name: 'Kseniya Korchagina (Beckman)', link: null },
	];

	const [lead, ...participants] = leaders;
	const renderPerson = (person, key) =>
		person.link ? (
			<a key={key} href={person.link} target="_blank" rel="noopener noreferrer">
				{person.name}
			</a>
		) : (
			<span key={key}>{person.name}</span>
		);

	return (
		<section className="WPinfo" ref={sectionRef}>
			<span className='wpinfo-icon'>
				<MicroscopeIcon />
			</span>
			<span className="WPinfo-body">
				<h2>Work package 1: Harmonized distributed technical platform for clinical tissue proteomics</h2>
				<p>
					<strong>Led by:</strong>{' '}
					{renderPerson(lead, 'lead')}
				</p>

				{participants.length > 0 && (
					<p>
						<strong>Participants:</strong>{' '}
						{participants.map((p, i) => (
						<React.Fragment key={i}>
							{renderPerson(p, i)}
							{i < participants.length - 1 && ', '}
						</React.Fragment>
						))}
						.
					</p>
				)}
				<div className={`expandable-content ${isExpanded ? 'expanded' : 'collapsed'}`}>
					This work package is dedicated to creating a harmonized framework that enables high-quality, reproducible tissue proteomics 
					across multiple sites. By developing standardized operating procedures that cover the full workflow—from sample collection 
					and preparation to advanced mass spectrometry analysis—we aim to ensure consistency and reliability in protein profiling. 
					A coordinated benchmarking effort will compare performance across partner laboratories and establish best practices, paving 
					the way for national and international harmonization. Ultimately, WP1 lays the foundation for prospective clinical use of 
					tissue proteomics through a harmonized technical platform and a roadmap toward certification and long-term sustainability. 
				</div>
				<button className="read-more-btn" onClick={toggleExpand}>
					{isExpanded ? 'Show Less' : 'Read More'}
				</button>
			</span>
		</section>
	);
});

export default WP1;
